export default __webpack_public_path__ + "static/LogoETH-c2e65de7ff172ac9d89d40f7b4e1f45d.svg";